import React from 'react';
import classnames from 'classnames';
import type { FieldGroupProps } from './types';
import Label from './Label';
import styled from 'styled-components';

interface Props extends FieldGroupProps {
  children: React.ReactNode;
  fullWidthOnMobile?: boolean;
}

const FieldGroup = ({
  id,
  required = false,
  label,
  hint,
  hideLabel = false,
  labelStyle = null,
  minWidthForLabel = undefined,
  isInline = false,
  error = null,
  fullWidthOnMobile = false,
  children,
}: Props): JSX.Element => (
  <div className={classnames({ 'flex items-center' : isInline, 'w-full md:w-auto': fullWidthOnMobile })}>
    <Label
      htmlFor={id}
      required={required}
      hideLabel={hideLabel}
      labelStyle={labelStyle}
      isInline={isInline}
      hint={hint}
      style={{
        marginRight: isInline ? 8 : 0,
        marginBottom: !isInline ? 8 : 0,
        minWidth: minWidthForLabel,
      }}
    >
      {label}
    </Label>
    {children}
    {error && (
      <FieldGroupErrorStyled>
        {error}
      </FieldGroupErrorStyled>
    )}
  </div>
);

const FieldGroupErrorStyled = styled('span')`
  display: block;
  margin-top: 4px;
  color: ${(props) => props.theme.colors.error};
`;

export default FieldGroup;
